var map = {
	"./baac.png": 967,
	"./bay.png": 968,
	"./bbl.png": 969,
	"./ghb.png": 970,
	"./gsb.png": 971,
	"./kbank.png": 972,
	"./ktb.png": 973,
	"./scb.png": 974,
	"./ttb.png": 975,
	"./uob.png": 976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 253;